module.exports = __webpack_public_path__ + "img/food-force-main-features.b2e2b822.webp";